import { useForm } from '@onfido/castor-react';
import { createContext, useContext } from 'react';
const FieldContext = createContext({});
export const useField = () => {
    const form = useForm();
    const field = useContext(FieldContext);
    return { ...omitNullish(form), ...omitNullish(field) };
};
export const FieldProvider = FieldContext.Provider;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const omitNullish = (obj) => Object.fromEntries(Object.entries(obj).filter(([, value]) => value != null));
//# sourceMappingURL=useField.js.map